var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.lastUpdate)?_c('small',[_vm._v("Last update: "+_vm._s(_vm.lastUpdateText))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }